module.exports = __webpack_public_path__ + "e6b7ff3bc1196bc0ed6ebd6b6a95cdcb.svg";